// src/utils/electricalUtils.js

// --- BASE DE DATOS NORMATIVA RIC N°04 (CHILE) ---
export const RIC4_DATA = {
    "70C_FIJO": {
        label: "Fijo 70°C (H07V, THWN, NYIFY)",
        methods: {
            "A1": { description: "A1 - Ducto embutido en pared aislante", data: [{s:1.5,a:13.5},{s:2.5,a:18},{s:4,a:24},{s:6,a:31},{s:10,a:42},{s:16,a:56},{s:25,a:73},{s:35,a:89},{s:50,a:108},{s:70,a:136},{s:95,a:164},{s:120,a:188},{s:150,a:215},{s:185,a:243},{s:240,a:285},{s:300,a:324}] },
            "B1": { description: "B1 - Ducto sobre pared", data: [{s:1.5,a:15.5},{s:2.5,a:21},{s:4,a:28},{s:6,a:36},{s:10,a:50},{s:16,a:68},{s:25,a:89},{s:35,a:110},{s:50,a:134},{s:70,a:171},{s:95,a:207},{s:120,a:239},{s:150,a:274},{s:185,a:311},{s:240,a:365},{s:300,a:415}] },
            "E": { description: "E - Aire libre / Bandeja", data: [{s:1.5,a:18.5},{s:2.5,a:25},{s:4,a:34},{s:6,a:43},{s:10,a:60},{s:16,a:80},{s:25,a:106},{s:35,a:131},{s:50,a:159},{s:70,a:202},{s:95,a:245},{s:120,a:285},{s:150,a:330},{s:185,a:375},{s:240,a:445},{s:300,a:510}] }
        }
    },
    "90C_FIJO": {
        label: "Fijo 90°C (RV-K, RZ1, THHN)",
        methods: {
            "A1": { description: "A1 - Ducto pared aislante", data: [{s:1.5,a:17},{s:2.5,a:23},{s:4,a:31},{s:6,a:40},{s:10,a:54},{s:16,a:73},{s:25,a:95},{s:35,a:117},{s:50,a:141},{s:70,a:179},{s:95,a:216},{s:120,a:249},{s:150,a:284},{s:185,a:322},{s:240,a:376},{s:300,a:429}] },
            "B1": { description: "B1 - Ducto sobre pared", data: [{s:1.5,a:20},{s:2.5,a:27},{s:4,a:37},{s:6,a:48},{s:10,a:66},{s:16,a:88},{s:25,a:117},{s:35,a:144},{s:50,a:175},{s:70,a:222},{s:95,a:269},{s:120,a:312},{s:150,a:358},{s:185,a:408},{s:240,a:481},{s:300,a:551}] },
            "D1": { description: "D1 - Enterrado ducto", data: [{s:1.5,a:26},{s:2.5,a:34},{s:4,a:44},{s:6,a:56},{s:10,a:75},{s:16,a:98},{s:25,a:128},{s:35,a:157},{s:50,a:186},{s:70,a:227},{s:95,a:275},{s:120,a:315},{s:150,a:355},{s:185,a:400},{s:240,a:465},{s:300,a:520}] },
            "D2": { description: "D2 - Enterrado directo", data: [{s:1.5,a:27},{s:2.5,a:36},{s:4,a:47},{s:6,a:59},{s:10,a:79},{s:16,a:103},{s:25,a:135},{s:35,a:164},{s:50,a:195},{s:70,a:238},{s:95,a:286},{s:120,a:328},{s:150,a:370},{s:185,a:417},{s:240,a:485},{s:300,a:545}] },
            "E": { description: "E - Bandeja/Aire", data: [{s:1.5,a:23},{s:2.5,a:32},{s:4,a:42},{s:6,a:54},{s:10,a:75},{s:16,a:100},{s:25,a:127},{s:35,a:158},{s:50,a:192},{s:70,a:246},{s:95,a:298},{s:120,a:346},{s:150,a:395},{s:185,a:450},{s:240,a:530},{s:300,a:600}] },
            "F": { description: "F - Unipolares contacto", data: [{s:1.5,a:25},{s:2.5,a:34},{s:4,a:46},{s:6,a:60},{s:10,a:84},{s:16,a:112},{s:25,a:148},{s:35,a:180},{s:50,a:225},{s:70,a:289},{s:95,a:352},{s:120,a:410},{s:150,a:470},{s:185,a:540},{s:240,a:640},{s:300,a:725}] }
        }
    },
    "MOVIL": { label: "Uso Móvil", methods: { "E": { description: "E - Aire libre", data: [{s:0.75,a:6},{s:1,a:10},{s:1.5,a:16},{s:2.5,a:25},{s:4,a:32},{s:6,a:40},{s:10,a:55},{s:16,a:75},{s:25,a:98},{s:35,a:125}] } } },
    "DESNUDO": { label: "Cobre Desnudo", methods: { "AEREO": { description: "Aéreo / Aisladores", data: [{s:10,a:80},{s:16,a:105},{s:25,a:140},{s:35,a:175},{s:50,a:215},{s:70,a:275},{s:95,a:340},{s:120,a:395}] } } }
};

export const RHO = { cobre: 0.018, aluminio: 0.028 };

export const CONDUIT_FILL_DATA = {
    conduit: { '16':132, '20':227, '25':346, '32':615, '40':907, '50':1520 },
    cable: { '1.5':7.1, '2.5':10.2, '4.0':13.9, '6.0':18.1, '10.0':28.3 }
};

export const electricalUtils = {
    // 1. Ley de Ohm
    calcOhmsLaw: ({ v, i, r, p }) => {
        const V=v?parseFloat(v):null; const I=i?parseFloat(i):null; const R=r?parseFloat(r):null; const P=p?parseFloat(p):null;
        const inputs=[V,I,R,P].filter(val=>val!==null);
        if(inputs.length<2) return { error: 'Se requieren 2 valores' };
        if(inputs.length>2) return { error: 'Ingrese solo 2 valores' };
        let nV=V,nI=I,nR=R,nP=P;
        if(V!=null&&I!=null){nR=V/I;nP=V*I}else if(V!=null&&R!=null){nI=V/R;nP=(V*V)/R}else if(V!=null&&P!=null){nI=P/V;nR=(V*V)/P}else if(I!=null&&R!=null){nV=I*R;nP=(I*I)*R}else if(I!=null&&P!=null){nV=P/I;nR=P/(I*I)}else if(R!=null&&P!=null){nV=Math.sqrt(P*R);nI=Math.sqrt(P/R)}
        return { v:nV.toFixed(2), i:nI.toFixed(2), r:nR.toFixed(2), p:nP.toFixed(2) };
    },

    // 2. Potencia
    calcPower: ({ phases, voltage, current, pf }) => {
        const V = parseFloat(voltage), I = parseFloat(current);
        let PF = parseFloat(pf);
        if (isNaN(V) || isNaN(I) || isNaN(PF) || V <= 0 || I < 0) return null;
        if (PF <= 0) PF = 0.01;
        if (PF > 1) PF = 1.0;
        let s = phases === '1' ? (V * I) / 1000 : (Math.sqrt(3) * V * I) / 1000;
        const p = s * PF;
        const q = Math.sqrt(Math.max(0, Math.pow(s, 2) - Math.pow(p, 2)));
        return { p: p.toFixed(2), s: s.toFixed(2), q: q.toFixed(2) };
    },

    // 3. Conductor (RIC N°04 y RIC N°10)
    calcConductor: ({ system, cableType, method, inputMode, power, current, voltage, distance, drop, pf, material = 'cobre', circuitType = 'fuerza', tempMode = '20' }) => {
        let P_watts = parseFloat(power) * 1000;
        let I_nominal = parseFloat(current) || 0;
        const V = parseFloat(voltage), L = parseFloat(distance), MAX_DROP = parseFloat(drop);
        let FP = parseFloat(pf) || 1.0;
        if (FP <= 0) FP = 0.01;
        if (FP > 1) FP = 1.0;

        if (V <= 0 || L <= 0 || MAX_DROP <= 0) return { error: 'Valores inválidos.' };
        const sqrt3 = Math.sqrt(3);

        if (inputMode === 'power') {
            if (system === 'monofasico') I_nominal = P_watts / (V * FP); else I_nominal = P_watts / (sqrt3 * V * FP);
        }

        const selectedCableData = RIC4_DATA[cableType];
        if (!selectedCableData || !selectedCableData.methods[method]) return { error: 'Método no válido.' };

        const table = selectedCableData.methods[method].data;
        const methodDesc = selectedCableData.methods[method].description;

        // Factor de resistividad según material y temperatura de régimen (RIC N°04)
        let materialRho = material === 'aluminio' ? 0.028 : 0.018;
        if (tempMode === 'regimen') {
            const is90C = cableType.includes('90C');
            if (material === 'cobre') {
                materialRho = is90C ? 0.023 : 0.0215; // 90°C vs 70°C
            } else {
                materialRho = is90C ? 0.036 : 0.0335;
            }
        }

        // Corrección de ampacidad estimada para Aluminio si se selecciona (aluminio conduce ~78% de cobre a igual sección)
        const alFactor = material === 'aluminio' ? 0.78 : 1.0;

        const rowAmpacity = table.find(r => (r.a * alFactor) >= I_nominal);
        const sectionByAmpacity = rowAmpacity ? rowAmpacity.s : table[table.length - 1].s;
        const ampacityMax = rowAmpacity ? (rowAmpacity.a * alFactor) : (table[table.length - 1].a * alFactor);
        const exceedsTable = I_nominal > ampacityMax;

        const K = system === 'monofasico' ? 2 : sqrt3;
        const deltaV_max = V * (MAX_DROP / 100);
        const sectionByDrop = (K * L * I_nominal * materialRho) / deltaV_max;

        // Secciones mínimas normativas según RIC N°03, RIC N°04 y RIC N°10
        let minNormativeSection = 1.5;
        let normativeRule = 'RIC N°10';

        if (circuitType === 'alimentador_general' || circuitType === 'alimentador') {
            // RIC N°03 Sec. 5.1.1: Sección mínima del alimentador general es 4 mm² para cobre y 10 mm² para aluminio
            minNormativeSection = material === 'aluminio' ? 10.0 : 4.0;
            normativeRule = 'RIC N°03 Sec. 5.1.1 (Alimentador General)';
        } else if (circuitType === 'subalimentador') {
            // RIC N°03 Sec. 5.1.2: Sección mínima de subalimentador es 2.5 mm² para cobre y 4 mm² para aluminio
            minNormativeSection = material === 'aluminio' ? 4.0 : 2.5;
            normativeRule = 'RIC N°03 Sec. 5.1.2 (Subalimentador)';
        } else if (circuitType === 'fuerza') {
            // RIC N°10 Sec. 5: Mínimo 2.5 mm² para enchufes / fuerza
            minNormativeSection = material === 'aluminio' ? 4.0 : 2.5;
            normativeRule = 'RIC N°10 Sec. 5 (Fuerza / Enchufes)';
        } else if (circuitType === 'alumbrado') {
            // RIC N°10 Sec. 5: Mínimo 1.5 mm² para alumbrado
            minNormativeSection = material === 'aluminio' ? 4.0 : 1.5;
            normativeRule = 'RIC N°10 Sec. 5 (Alumbrado)';
        }

        // Si se utiliza aluminio, RIC N°04 Sección 5.1 exige no emplear calibres inferiores a 4.0 mm²
        if (material === 'aluminio' && minNormativeSection < 4.0) {
            minNormativeSection = 4.0;
        }

        const sectionFinal = Math.max(sectionByAmpacity, sectionByDrop, minNormativeSection);
        const finalRow = table.find(r => r.s >= sectionFinal) || table[table.length - 1];
        const commercialSection = finalRow.s;

        const isRestrictedByNorm = commercialSection === minNormativeSection && Math.max(sectionByAmpacity, sectionByDrop) < minNormativeSection;

        const deltaV_real = (K * L * I_nominal * materialRho) / commercialSection;
        const drop_real_percent = (deltaV_real / V) * 100;
        
        return { 
            currentNominal: I_nominal.toFixed(1),
            sectionDrop: sectionByDrop.toFixed(3),
            sectionAmpacity: sectionByAmpacity.toFixed(2),
            commercial: commercialSection,
            minNormative: minNormativeSection,
            normativeRule,
            isRestrictedByNorm,
            deltaVReal: deltaV_real.toFixed(2),
            dropRealPercent: drop_real_percent.toFixed(2),
            tableInfo: methodDesc,
            rhoUsed: materialRho,
            exceedsTable,
            error: null
        };
    },

    // 4. Cortocircuito y Sección de Tierra (RIC N°05 y RIC N°06)
    calcShortCircuit: ({ system, voltage, kva, z, l, s, mat, t_fault, k_factor }) => {
        const V = parseFloat(voltage); 
        const S_kVA = parseFloat(kva);
        const Z_percent = parseFloat(z);
        const L_m = parseFloat(l);
        const S_mm2 = parseFloat(s);

        if (!V || !S_kVA || !Z_percent || !L_m || !S_mm2) return null;

        let I_cc_tr, V_LN, Z_tr, Z_cable, Z_total, I_cc_load;

        if (system === '3') {
            const I_n_tr = (S_kVA * 1000) / (Math.sqrt(3) * V);
            I_cc_tr = I_n_tr / (Z_percent / 100);
            V_LN = V / Math.sqrt(3);
            Z_tr = (V_LN / I_cc_tr) * 1000; 
            
            const R_tr = 0.3 * Z_tr;
            const X_tr = 0.95 * Z_tr;
            
            const rho = mat === 'Cu' ? 0.018 : 0.028;
            const R_cable = (rho * L_m / S_mm2) * 1000; 
            const X_cable = 0.08 * L_m; 
            Z_cable = Math.sqrt(R_cable**2 + X_cable**2);
            
            const R_total = R_tr + R_cable;
            const X_total = X_tr + X_cable;
            Z_total = Math.sqrt(R_total**2 + X_total**2);
            
            I_cc_load = (V_LN / (Z_total / 1000));
        } else {
            const I_n_tr = (S_kVA * 1000) / V;
            I_cc_tr = I_n_tr / (Z_percent / 100);
            V_LN = V; 
            Z_tr = (V / I_cc_tr) * 1000; 
            
            const R_tr = 0.3 * Z_tr;
            const X_tr = 0.95 * Z_tr;
            
            const rho = mat === 'Cu' ? 0.018 : 0.028;
            const R_cable = 2 * (rho * L_m / S_mm2) * 1000; 
            const X_cable = 2 * 0.08 * L_m;
            Z_cable = Math.sqrt(R_cable**2 + X_cable**2);
            
            const R_total = R_tr + R_cable;
            const X_total = X_tr + X_cable;
            Z_total = Math.sqrt(R_total**2 + X_total**2);
            
            I_cc_load = (V / (Z_total / 1000));
        }

        const I_cc_load_amps = I_cc_load; 
        const S_earth_adiabatic = (Math.sqrt(Math.pow(I_cc_load_amps, 2) * t_fault)) / k_factor;

        // Sección mínima de Tierra de Protección (PE) según Tabla 6.2 del RIC N°06:
        // S_fase <= 16 mm² -> S_PE = S_fase
        // 16 < S_fase <= 35 mm² -> S_PE = 16 mm²
        // S_fase > 35 mm² -> S_PE = S_fase / 2
        let S_earth_table = S_mm2;
        if (S_mm2 <= 16) {
            S_earth_table = S_mm2;
        } else if (S_mm2 <= 35) {
            S_earth_table = 16;
        } else {
            S_earth_table = S_mm2 / 2;
        }

        const commercialSections = [1.5, 2.5, 4, 6, 10, 16, 25, 35, 50, 70, 95, 120, 150, 185, 240, 300];
        const S_earth_required = Math.max(S_earth_adiabatic, S_earth_table);
        const finalEarthCommercial = commercialSections.find(cs => cs >= S_earth_required) || S_earth_required;
        const governsBy = S_earth_adiabatic > S_earth_table ? 'Cálculo Adiabático (Icc)' : 'Tabla 6.2 RIC N°06';

        return {
            icc_tr: (I_cc_tr / 1000).toFixed(1), 
            icc_load: (I_cc_load / 1000).toFixed(2),
            z_total: Z_total.toFixed(1),
            z_tr: Z_tr.toFixed(1),
            z_cable: Z_cable.toFixed(1),
            earth_adiabatic: S_earth_adiabatic.toFixed(2),
            earth_table: S_earth_table.toFixed(1),
            earth_section: finalEarthCommercial,
            governsBy
        };
    },

    // 5. Factor Potencia
    calcPowerFactor: ({ power, currentPf, targetPf, loadType, steps }) => {
        const P = parseFloat(power);
        const PF1 = parseFloat(currentPf);
        const PF2 = parseFloat(targetPf);

        if (!P || !PF1 || !PF2 || PF1 <= 0 || PF1 >= 1 || PF2 <= 0 || PF2 > 1) {
            return { error: 'Datos inválidos. FP debe estar entre 0 y 1.' };
        }

        const phi1 = Math.acos(PF1);
        const phi2 = Math.acos(PF2);

        let Q1 = P * Math.tan(phi1);
        if (loadType === 'capacitive') Q1 = -Q1;

        const Q2 = P * Math.tan(phi2);
        const Qc_total = Q1 - Q2;
        const equipmentType = Qc_total > 0 ? 'Banco de Condensadores' : 'Reactores Inductivos';
        const compensationValue = Math.abs(Qc_total);

        const numSteps = parseInt(steps);
        const stepValue = compensationValue / numSteps;
        const stepsArray = Array(numSteps).fill(stepValue);
        const maxVal = Math.max(P, Math.abs(Q1), Math.abs(Q2), Math.abs(Qc_total));
        const scale = 180 / maxVal;

        return {
            kvar: compensationValue.toFixed(2),
            type: equipmentType,
            q1: Q1, q2: Q2, qc: Qc_total,
            steps: stepsArray,
            scale: scale,
            phi1: loadType === 'inductive' ? phi1 : -phi1,
            phi2: phi2,
            error: null
        };
    },

    // 6. Motores
    calcMotor: ({ u, p, v, ph, eff, pf }) => {
        let Pw = parseFloat(p);
        if(u === 'hp') Pw *= 745.7; else Pw *= 1000;
        const V = parseFloat(v);
        const PF = parseFloat(pf);
        const EFF = parseFloat(eff);
        let I = 0;
        if(ph === '1') I = Pw / (V * PF * EFF);
        else I = Pw / (Math.sqrt(3) * V * PF * EFF);
        return I.toFixed(2);
    },

    // 7. Relé Térmico (RIC N°07 y NEC 430.32)
    calcThermalRelay: ({ mode = 'calc', directIn, u, p, v, ph, sf = '1.15', eff = 0.85, pf = 0.85 }) => {
        let In = 0;
        if (mode === 'direct') {
            In = parseFloat(directIn);
            if (isNaN(In) || In <= 0) return null;
        } else {
            const EFF = parseFloat(eff) || 0.85;
            const PF = parseFloat(pf) || 0.85;
            let Pw = parseFloat(p);
            if (u === 'hp') Pw *= 745.7; else Pw *= 1000;
            const V = parseFloat(v);
            if (isNaN(Pw) || isNaN(V) || V <= 0 || Pw <= 0) return null;
            if (ph === '1') In = Pw / (V * PF * EFF);
            else In = Pw / (Math.sqrt(3) * V * PF * EFF);
        }

        const m = parseFloat(sf) >= 1.15 ? 1.25 : 1.15;
        const maxTrip = In * m;
        return { 
            n: In.toFixed(2), 
            m: maxTrip.toFixed(2),
            recommended: In.toFixed(2),
            rangeMin: (In * 0.90).toFixed(2),
            rangeMax: maxTrip.toFixed(2),
            factor: m
        };
    },

    // 8. Caída DC (Sistemas Solares y Baterías - RIC N°08 y N°09)
    calcDropDC: ({ v, i, d, s, mat = 'Cu' }) => {
        const V = parseFloat(v), I = parseFloat(i), L = parseFloat(d), S = parseFloat(s);
        if (!V || !I || !L || !S || V <= 0 || S <= 0) return null;
        const rho = mat === 'Al' ? 0.028 : 0.018;
        const vd = (2 * L * I * rho) / S;
        const p = (vd / V) * 100;
        return { 
            v: vd.toFixed(2), 
            p: p.toFixed(2),
            compliesSolar: p <= 1.5, // RIC N°09 Sec. 6: Caída máx 1.5% en CC generador FV a inversor
            compliesBattery: p <= 3.0 // Caída máx recomendada 3% en sistemas de almacenamiento
        };
    },

    // 9. Baterías y Autonomía UPS/Solar
    calcBatteryBackup: ({ w, v, ah, eff = 0.85, dod = 0.5 }) => {
        const W = parseFloat(w), V = parseFloat(v), Ah = parseFloat(ah);
        const EFF = parseFloat(eff) || 0.85;
        const DOD = parseFloat(dod) || 0.5;
        if (!W || !V || !Ah || W <= 0 || V <= 0 || Ah <= 0) return null;
        const h = (V * Ah * DOD) / (W / EFF);
        return h.toFixed(1);
    },
    
    // 10. Ocupación de Ductos (RIC N°04 Sección 7)
    calcConduitFill: ({ c, w, factor = 0.40 }) => {
        const conduitArea = CONDUIT_FILL_DATA.conduit[c];
        const cableArea = CONDUIT_FILL_DATA.cable[w];
        if (!conduitArea || !cableArea) return 0;
        const f = parseFloat(factor) || 0.40;
        const max = Math.floor((conduitArea * f) / cableArea);
        return max;
    },

    // 11. Conversor Técnico (Longitud, Temp, Potencia, AWG <-> mm²)
    calcUnitConverter: ({ t, v }) => {
        const val = parseFloat(v);
        if (t === 'len_m_ft') {
            if (isNaN(val)) return null;
            return `${(val * 3.28084).toFixed(2)} ft`;
        }
        if (t === 'len_ft_m') {
            if (isNaN(val)) return null;
            return `${(val / 3.28084).toFixed(2)} m`;
        }
        if (t === 'temp_c_f') {
            if (isNaN(val)) return null;
            return `${((val * 9/5) + 32).toFixed(1)} °F`;
        }
        if (t === 'temp_f_c') {
            if (isNaN(val)) return null;
            return `${(((val - 32) * 5) / 9).toFixed(1)} °C`;
        }
        if (t === 'power_hp_kw') {
            if (isNaN(val)) return null;
            return `${(val * 0.7457).toFixed(2)} kW`;
        }
        if (t === 'power_kw_hp') {
            if (isNaN(val)) return null;
            return `${(val / 0.7457).toFixed(2)} HP`;
        }
        if (t === 'awg_mm') {
            const found = AWG_TABLE.find(item => item.awg === v);
            return found ? `${found.mm2} mm² (${found.note})` : null;
        }
        return '';
    }
};

export const AWG_TABLE = [
    { awg: '14 AWG', mm2: 2.08, note: 'Solo control/señal. No apto enchufes en Chile (RIC N°10 exige mín 2.5 mm²)' },
    { awg: '12 AWG', mm2: 3.31, note: 'Equiv. comercial métrico: 4.0 mm²' },
    { awg: '10 AWG', mm2: 5.26, note: 'Equiv. comercial métrico: 6.0 mm²' },
    { awg: '8 AWG', mm2: 8.37, note: 'Equiv. comercial métrico: 10.0 mm²' },
    { awg: '6 AWG', mm2: 13.30, note: 'Equiv. comercial métrico: 16.0 mm²' },
    { awg: '4 AWG', mm2: 21.15, note: 'Equiv. comercial métrico: 25.0 mm²' },
    { awg: '2 AWG', mm2: 33.62, note: 'Equiv. comercial métrico: 35.0 mm²' },
    { awg: '1 AWG', mm2: 42.41, note: 'Equiv. comercial métrico: 50.0 mm²' },
    { awg: '1/0 AWG', mm2: 53.49, note: 'Equiv. comercial métrico: 50/70 mm²' },
    { awg: '2/0 AWG', mm2: 67.43, note: 'Equiv. comercial métrico: 70.0 mm²' },
    { awg: '3/0 AWG', mm2: 85.01, note: 'Equiv. comercial métrico: 95.0 mm²' },
    { awg: '4/0 AWG', mm2: 107.22, note: 'Equiv. comercial métrico: 120.0 mm²' },
    { awg: '250 kcmil', mm2: 126.68, note: 'Equiv. comercial métrico: 150.0 mm²' },
    { awg: '300 kcmil', mm2: 152.01, note: 'Equiv. comercial métrico: 150/185 mm²' },
    { awg: '350 kcmil', mm2: 177.35, note: 'Equiv. comercial métrico: 185.0 mm²' },
    { awg: '500 kcmil', mm2: 253.35, note: 'Equiv. comercial métrico: 300.0 mm²' }
];